import { Box, Text } from "@chakra-ui/react";
import {
  EhrName,
  EhrProvider,
  PatientOverview,
  PatientOverviewV2,
  SharedStateProvider,
} from "@metriport/shared-internal";
import { ossBaseUrlEClinicalWorks } from "../../../api/api";
import { useAppContext } from "../../contexts/app/index";

export default function PatientPage() {
  const { state } = useAppContext();

  if (!state.isLoaded) {
    return null;
  }

  const ehrDetails = {
    ehrPatientId: state.ehrPatientId,
    name: EhrName.EClinicalWorks,
  };

  return (
    <Box>
      {state.ehrPatientId ? (
        <SharedStateProvider
          authToken={state.authToken}
          baseUrl={ossBaseUrlEClinicalWorks}
          ehrDetails={ehrDetails}
          featureFlags={state.featureFlags}
        >
          {state.featureFlags.shouldShowLegacyDashV1 ? (
            <PatientOverview patientId={state.ehrPatientId} />
          ) : (
            // after v1 code is removed, remove ehrDetails from SharedStateProvider ^!
            <EhrProvider patientId={state.ehrPatientId} ehrDetails={ehrDetails}>
              <PatientOverviewV2 patientId={state.ehrPatientId} />
            </EhrProvider>
          )}
        </SharedStateProvider>
      ) : (
        <Text>No Patient</Text>
      )}
    </Box>
  );
}
